import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API });

// Attach facilitator admin bearer token (Emergent Google Auth) when present.
api.interceptors.request.use((config) => {
  try {
    const t = localStorage.getItem("dig_admin_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
  } catch (e) {}
  return config;
});

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  if (path.startsWith("/api/files/")) return `${BACKEND}${path}`;
  return `${API}/files/${path}`;
}

export function wsUrl(code, role, teamId) {
  const base = BACKEND.replace(/^http/, "ws");
  let url = `${base}/api/ws/${code}?role=${role}`;
  if (teamId) url += `&team_id=${teamId}`;
  return url;
}

export const CATEGORY = {
  PARTNER: { hex: "#1B7FA8", tint: "#DEEDF4", text: "#FFFFFF", icon: "/dig/icons/icon-handshake.png", es: "Socio", en: "Partner" },
  PAIN: { hex: "#F2695C", tint: "#FDE7E4", text: "#FFFFFF", icon: "/dig/icons/icon-pain.png", es: "Dolor", en: "Pain" },
  TRIBE: { hex: "#2EC4B6", tint: "#DFF6F4", text: "#FFFFFF", icon: "/dig/icons/icon-tribe.png", es: "Tribu", en: "Tribe" },
  TOOL: { hex: "#FDBB2F", tint: "#FEF2D8", text: "#12333F", icon: "/dig/icons/icon-tool.png", es: "Herramienta", en: "Tool" },
  TWIST: { hex: "#12333F", tint: "#E3E9EB", text: "#FDBB2F", icon: "/dig/icons/icon-twist.png", es: "Giro", en: "Twist" },
};
